<div class="input-container">
  @if (!hideSearchIcon) {
    <oph-icon [name]="'list-views/search'" [size]="22"></oph-icon>
  }
  <input
    type="text"
    class="example-input"
    [placeholder]="placeholder || ''"
    [matAutocomplete]="auto"
    [ngStyle]="style"
    [disabled]="inputDisabled"
    [value]="value"
    (input)="onInput($any($event.target).value)"
    (blur)="onBlur()"
    #input
  />
</div>

<mat-autocomplete #auto="matAutocomplete" (opened)="menuOpen = true" (closed)="menuOpen = false">
  @if (filteredOptions?.length) {
    @for (option of filteredOptions; track option; let i = $index) {
      <div class="oph-autocomplete-option">
        <mat-option
          [value]="preventSelectedOption ? null : option"
          (click)="onOption(option, i)"
          [disabled]="option.disabled"
        >
          {{ option.name }}
        </mat-option>
        @if (optionIcon) {
          <oph-icon [name]="optionIcon" [size]="18"></oph-icon>
        }
      </div>
    }
  } @else {
    <mat-option [disabled]="true">{{ noOptionsText || 'No options found' }}</mat-option>
  }
</mat-autocomplete>
